/**
 * Çarkıfelek / Gift Wheel — storefront widget
 * Konfig: <script id="gift-wheel-config"> (shop metafield JSON)
 * Spin:   POST /apps/wishlist/wheel/spin (ödül SUNUCU tarafında belirlenir)
 */
(function () {
  "use strict";

  var SPIN_ENDPOINT = "/apps/wishlist/wheel/spin";

  // "Altın Gece" çark tasarımı — admin önizlemesiyle (app/utils/gift-wheel-design.js)
  // aynı değerler. Ölçüler 400x400 viewBox'ta; çark CSS ile ölçeklenir.
  var SVG_NS = "http://www.w3.org/2000/svg";
  var WHEEL_C = 200;
  var WHEEL_RIM_R = 194;
  var WHEEL_INNER_R = 165;
  var WHEEL_SLICE_R = 160;
  var WHEEL_BULB_RING_R = 176;
  var WHEEL_BULB_COUNT = 20;
  var WHEEL_LABEL_MIN_FONT = 9;
  var WHEEL_LABEL_MAX_CHARS = 24;
  var WHEEL_GOLD_SLICE = "#e9a90c"; // bu renkteki dilim altın gradyanla çizilir
  var WHEEL_COLORS = {
    rimLight: "#FFE9A0",
    rimMid: "#E0A626",
    rimDark: "#8A5A0B",
    inner: "#1A1238",
    separator: "#F5C542",
    goldLight: "#FFE38A",
    bulbA: "#FFF6D6",
    bulbB: "#FFB400",
    jewel: "#C8173A",
  };
  var WHEEL_FONT_FAMILY = "'Bricolage Grotesque', system-ui, -apple-system, 'Segoe UI', Arial, sans-serif";
  // @font-face component-gift-wheel.css'te (tema asset'i, harici servis yok); latin-ext için Türkçe harfler
  var WHEEL_FONT_SAMPLE = "ÇEVİR ĞğŞşİı 0123456789 %TL";
  var WHEEL_SPIN_MS = 5000;
  var WHEEL_RESULT_DELAY_MS = 5200;
  var WHEEL_SPIN_EASE = "cubic-bezier(0.15, 0.7, 0.1, 1)";
  var WHEEL_SPIN_TURNS = 6;
  var HUB_LABEL = "ÇEVİR";
  // ready(init) bu IIFE'nin başında senkron çalışabilir → durum burada (init'ten önce) atanmalı
  var wheelFontState = 0; // 0: yok, 1: yükleniyor, 2: hazır (ya da başarısız → yedek font)
  var wheelFontCallbacks = [];

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        if (k === "class") n.className = attrs[k];
        else if (k === "html") n.innerHTML = attrs[k];
        else if (k === "text") n.textContent = attrs[k];
        else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
      }
    }
    if (children) {
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (c == null) continue;
        n.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
      }
    }
    return n;
  }

  ready(init);

  function init() {
    var root = document.getElementById("gift-wheel-root");
    if (!root) return;
    var configEl = document.getElementById("gift-wheel-config");
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent || configEl.innerHTML);
    } catch (e) {
      return;
    }
    if (!config || !config.enabled) return;
    if (!config.prizes || !config.prizes.length) return;

    var ctx = {
      loggedIn: root.getAttribute("data-logged-in") === "true",
      customerId: root.getAttribute("data-customer-id") || "",
      pageType: root.getAttribute("data-page-type") || "",
      cartPath: root.getAttribute("data-cart-path") || "/cart",
      loginUrl: root.getAttribute("data-login-url") || "/account/login",
    };

    var seg = config.segment || "all";
    if (seg === "members" && !ctx.loggedIn) return;
    if (seg === "guests" && ctx.loggedIn) return;

    var display = config.display || {};
    if (!pageAllowed(display.pages, ctx.pageType)) return;
    if (sessionDismissed()) return;
    if (!frequencyOk(display)) return;

    var state = { shown: false, spinning: false, done: false };
    ensureWheelFont();

    var trigger = display.trigger || "delay";
    if (trigger === "load") {
      open();
    } else if (trigger === "scroll") {
      onScroll(Number(display.scrollPercent) || 40, open);
    } else if (trigger === "exit") {
      onExit(open);
    } else {
      setTimeout(open, (Number(display.delaySeconds) || 5) * 1000);
    }

    function open() {
      if (state.shown) return;
      state.shown = true;
      buildModal(config, ctx, state);
    }
  }

  // ---------- Gating helpers ----------

  function pageAllowed(pages, pt) {
    if (!pages || pages.indexOf("all") >= 0) return true;
    var map = {
      home: "index",
      product: "product",
      collection: "collection",
      cart: "cart",
      search: "search",
      page: "page",
      blog: "blog",
      article: "article",
    };
    for (var i = 0; i < pages.length; i++) {
      var key = pages[i];
      if (key === "account") {
        if (pt.indexOf("customers") === 0 || pt.indexOf("account") >= 0) return true;
      } else if (map[key] === pt) {
        return true;
      }
    }
    return false;
  }

  function freqMs(display) {
    var v = Number(display.frequencyValue) || 0;
    if (v <= 0) return 0;
    return (display.frequencyUnit === "days" ? 86400000 : 3600000) * v;
  }

  function frequencyOk(display) {
    var ms = freqMs(display);
    if (ms <= 0) return true;
    try {
      var last = localStorage.getItem("gw_last_spin");
      if (last && Date.now() - Number(last) < ms) return false;
    } catch (e) {}
    return true;
  }

  function markSpun() {
    try {
      localStorage.setItem("gw_last_spin", String(Date.now()));
    } catch (e) {}
  }

  function sessionDismissed() {
    try {
      return sessionStorage.getItem("gw_dismissed") === "1";
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      sessionStorage.setItem("gw_dismissed", "1");
    } catch (e) {}
  }

  function onScroll(percent, cb) {
    var fired = false;
    function handler() {
      if (fired) return;
      var h = document.documentElement;
      var scrolled = (h.scrollTop || document.body.scrollTop) + window.innerHeight;
      var total = h.scrollHeight || document.body.scrollHeight;
      if (total > 0 && (scrolled / total) * 100 >= percent) {
        fired = true;
        window.removeEventListener("scroll", handler);
        cb();
      }
    }
    window.addEventListener("scroll", handler, { passive: true });
  }

  function onExit(cb) {
    var fired = false;
    document.addEventListener("mouseout", function (e) {
      if (fired) return;
      if (!e.relatedTarget && e.clientY <= 0) {
        fired = true;
        cb();
      }
    });
  }

  // ---------- Modal ----------

  function buildModal(config, ctx, state) {
    var a = config.appearance || {};
    var overlay = el("div", { class: "gw-overlay" });
    overlay.style.setProperty("--gw-overlay-bg", "rgba(0,0,0," + (a.overlayOpacity != null ? a.overlayOpacity : 0.6) + ")");
    overlay.style.setProperty("--gw-modal-bg", a.modalBg || "#fff");
    overlay.style.setProperty("--gw-text", a.textColor || "#1a1a1a");
    overlay.style.setProperty("--gw-btn", a.buttonColor || "#3a3a3a");
    overlay.style.setProperty("--gw-btn-text", a.buttonTextColor || "#fff");
    overlay.style.setProperty("--gw-pointer", a.pointerColor || "#e3242b");
    overlay.style.setProperty("--gw-radius", (a.borderRadius != null ? a.borderRadius : 16) + "px");
    if (a.fontFamily && a.fontFamily !== "inherit") {
      overlay.style.setProperty("--gw-font", a.fontFamily);
    }

    var modal = el("div", { class: "gw-modal" + (a.layout === "left" ? " gw-layout-left" : "") });

    // Kapatma
    if (config.display && config.display.showCloseButton) {
      var closeBtn = el("button", { class: "gw-close", type: "button", "aria-label": "Kapat", html: "&times;" });
      closeBtn.addEventListener("click", function () {
        close(true);
      });
      modal.appendChild(closeBtn);
    }

    // Çark sütunu — ortadaki ÇEVİR de ana butonla aynı akışı tetikler
    var wheel = buildWheel(config.prizes, a, function () {
      submitSpin(true);
    });
    var wheelCol = el("div", { class: "gw-wheel-col" }, [wheel.wrap]);

    // Form sütunu
    var formCol = el("div", { class: "gw-form-col" });
    formCol.appendChild(el("h2", { class: "gw-title", text: config.title || "Çarkı Çevir!" }));
    if (config.subtitle) formCol.appendChild(el("p", { class: "gw-subtitle", text: config.subtitle }));

    var fields = config.fields || {};
    var inputs = {};
    ["name", "phone", "email"].forEach(function (key) {
      var f = fields[key];
      if (!f || !f.enabled) return;
      var input = el("input", {
        class: "gw-input",
        type: key === "email" ? "email" : "text",
        placeholder: f.label || key,
        autocomplete: key === "name" ? "name" : key === "email" ? "email" : "tel",
      });
      if (key === "phone") input.setAttribute("inputmode", "tel");
      var errSpan = el("span", { class: "gw-field-error" });
      inputs[key] = { input: input, err: errSpan };
      formCol.appendChild(el("div", { class: "gw-field" }, [input, errSpan]));
    });

    // Onaylar
    var consentEls = [];
    (config.consents || []).forEach(function (c) {
      var cb = el("input", { type: "checkbox" });
      var label = el("label", { class: "gw-consent" }, [cb, el("span", { text: c.text || "" })]);
      consentEls.push({ id: c.id, required: !!c.required, cb: cb, label: label });
      formCol.appendChild(label);
    });

    var msg = el("div", { class: "gw-msg" });
    var spinBtn = el("button", { class: "gw-spin-btn", type: "button", text: config.buttonText || "Çevir Kazan" });
    formCol.appendChild(spinBtn);
    formCol.appendChild(msg);

    spinBtn.addEventListener("click", function () {
      submitSpin();
    });

    modal.appendChild(wheelCol);
    modal.appendChild(formCol);
    overlay.appendChild(modal);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay && config.display && config.display.showCloseButton) close(true);
    });

    document.body.appendChild(overlay);
    fitWheelLabels(wheel.svg);
    ensureWheelFont(function () {
      fitWheelLabels(wheel.svg);
    });
    requestAnimationFrame(function () {
      overlay.classList.add("gw-open");
    });

    function close(dismiss) {
      if (dismiss) markDismissed();
      overlay.classList.remove("gw-open");
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 300);
    }

    function clearErrors() {
      msg.className = "gw-msg";
      msg.textContent = "";
      for (var k in inputs) {
        inputs[k].input.classList.remove("gw-invalid");
        inputs[k].err.textContent = "";
      }
      consentEls.forEach(function (c) {
        c.label.classList.remove("gw-consent-missing");
      });
    }

    function validate() {
      clearErrors();
      var ok = true;
      if (inputs.name && fields.name.required && !inputs.name.input.value.trim()) {
        inputs.name.input.classList.add("gw-invalid");
        inputs.name.err.textContent = "Ad Soyad zorunludur";
        ok = false;
      }
      if (inputs.phone) {
        var digits = inputs.phone.input.value.replace(/\D/g, "");
        if (digits.length === 11 && digits.charAt(0) === "0") digits = digits.slice(1);
        if (digits.length === 12 && digits.slice(0, 2) === "90") digits = digits.slice(2);
        var validPhone = digits.length === 10 && digits.charAt(0) === "5";
        if ((fields.phone.required || inputs.phone.input.value) && !validPhone) {
          inputs.phone.input.classList.add("gw-invalid");
          inputs.phone.err.textContent = "Geçerli bir cep telefonu giriniz (5xx xxx xx xx)";
          ok = false;
        }
      }
      if (inputs.email && fields.email.required) {
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inputs.email.input.value)) {
          inputs.email.input.classList.add("gw-invalid");
          inputs.email.err.textContent = "Geçerli bir e-posta giriniz";
          ok = false;
        }
      }
      var consentMissing = false;
      consentEls.forEach(function (c) {
        if (c.required && !c.cb.checked) {
          c.label.classList.add("gw-consent-missing");
          consentMissing = true;
        }
      });
      if (consentMissing) {
        msg.className = "gw-msg gw-msg-error";
        msg.textContent = "Devam etmek için yasal onayları işaretleyin.";
        ok = false;
      }
      return ok;
    }

    function submitSpin(fromHub) {
      if (state.spinning || state.done) return;
      if (!validate()) {
        // Hub'dan tetiklendiyse (mobilde form çarkın altında) hatayı görünür yap
        if (fromHub) revealFirstError();
        return;
      }

      var consents = {};
      consentEls.forEach(function (c) {
        consents[c.id] = !!c.cb.checked;
      });

      var payload = {
        name: inputs.name ? inputs.name.input.value.trim() : "",
        phone: inputs.phone ? inputs.phone.input.value.trim() : "",
        email: inputs.email ? inputs.email.input.value.trim() : "",
        customerId: ctx.customerId || null,
        consents: consents,
        pageType: ctx.pageType,
      };

      state.spinning = true;
      spinBtn.disabled = true;
      wheel.setBusy(true);
      var originalText = spinBtn.textContent;
      spinBtn.textContent = "Çevriliyor...";

      fetch(SPIN_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { status: res.status, data: data };
          });
        })
        .then(function (r) {
          var data = r.data || {};

          if (data.ok && typeof data.prizeIndex === "number" && data.prizeIndex >= 0) {
            spinWheel(wheel.rotor, data.prizeIndex, config.prizes.length, function () {
              state.done = true;
              wheel.lock();
              markSpun();
              showResult(data);
            });
            return;
          }

          // Hata durumları
          state.spinning = false;
          spinBtn.disabled = false;
          wheel.setBusy(false);
          spinBtn.textContent = originalText;

          if (r.status === 401 || data.error === "login_required") {
            msg.className = "gw-msg gw-msg-error";
            msg.innerHTML = "";
            msg.appendChild(document.createTextNode((data.message || "Giriş yapmanız gerekiyor.") + " "));
            var lnk = el("a", { href: ctx.loginUrl, text: "Giriş yap" });
            msg.appendChild(lnk);
          } else if (r.status === 429 || data.error === "already_spun") {
            state.done = true;
            wheel.lock();
            markSpun();
            if (data.previous && data.previous.code) {
              showResult({
                win: true,
                title: "Zaten kazandınız 🎁",
                message: "Daha önce çarkı çevirdiniz. Kupon kodunuz:",
                code: data.previous.code,
                prizeLabel: data.previous.prizeLabel,
                nextSpinMessage: data.nextSpinMessage,
              });
            } else {
              showResult({
                win: false,
                title: "Tekrar deneyin",
                message: data.message || "Yakın zamanda çarkı çevirdiniz.",
                nextSpinMessage: data.nextSpinMessage,
              });
            }
          } else if (data.fieldErrors) {
            for (var fk in data.fieldErrors) {
              if (inputs[fk]) {
                inputs[fk].input.classList.add("gw-invalid");
                inputs[fk].err.textContent = data.fieldErrors[fk];
              }
            }
            msg.className = "gw-msg gw-msg-error";
            msg.textContent = data.message || "Lütfen bilgileri kontrol edin.";
          } else {
            msg.className = "gw-msg gw-msg-error";
            msg.textContent = data.message || "Bir hata oluştu, lütfen tekrar deneyin.";
          }
        })
        .catch(function () {
          state.spinning = false;
          spinBtn.disabled = false;
          wheel.setBusy(false);
          spinBtn.textContent = originalText;
          msg.className = "gw-msg gw-msg-error";
          msg.textContent = "Bağlantı hatası, lütfen tekrar deneyin.";
        });
    }

    function revealFirstError() {
      var target = null;
      for (var k in inputs) {
        if (!target && inputs[k].input.classList.contains("gw-invalid")) target = inputs[k].input;
      }
      if (target) {
        target.focus();
      } else if (msg.textContent && msg.scrollIntoView) {
        msg.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    }

    function showResult(data) {
      var box = el("div", { class: "gw-result" });
      box.appendChild(el("h2", { class: "gw-result-title", text: data.title || (data.win ? "Tebrikler!" : "Bu sefer olmadı") }));
      if (data.message) box.appendChild(el("p", { class: "gw-result-msg", text: data.message }));

      if (data.win && data.code) {
        var codeSpan = el("span", { class: "gw-code", text: data.code });
        var copyBtn = el("button", { class: "gw-copy-btn", type: "button", text: "Kopyala" });
        copyBtn.addEventListener("click", function () {
          copyText(data.code);
          copyBtn.textContent = "Kopyalandı ✓";
        });
        box.appendChild(el("div", { class: "gw-code-box" }, [codeSpan, copyBtn]));

        var applyHref = "/discount/" + encodeURIComponent(data.code) + "?redirect=" + encodeURIComponent(ctx.cartPath || "/");
        box.appendChild(el("a", { class: "gw-apply-btn", href: applyHref, text: "Kuponu Kullan" }));

        if (data.smsSent) {
          box.appendChild(el("p", { class: "gw-sms-note", text: "Kupon kodu telefonunuza SMS olarak da gönderildi." }));
        }
      }

      // Sunucu, admin'deki "Tekrar gösterme aralığı"na göre hazır metni döner
      // ("Çarkı tekrar çevirme hakkınız 3 Ekim 2026 tarihinde yenilenecektir.")
      if (data.nextSpinMessage) {
        box.appendChild(el("p", { class: "gw-respin-note", text: data.nextSpinMessage }));
      }

      var okBtn = el("button", { class: "gw-spin-btn", type: "button", text: "Kapat" });
      okBtn.addEventListener("click", function () {
        close(false);
      });
      box.appendChild(okBtn);

      formCol.innerHTML = "";
      formCol.appendChild(box);
    }
  }

  // ---------- Wheel: "Altın Gece" tasarımı (SVG) ----------

  function svgEl(tag, attrs, children) {
    var n = document.createElementNS(SVG_NS, tag);
    if (attrs) {
      for (var k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k) && attrs[k] != null) n.setAttribute(k, String(attrs[k]));
      }
    }
    if (children) {
      for (var i = 0; i < children.length; i++) {
        if (children[i]) n.appendChild(children[i]);
      }
    }
    return n;
  }

  function radialGradient(id, cx, cy, r, stops) {
    var nodes = [];
    for (var i = 0; i < stops.length; i++) {
      nodes.push(svgEl("stop", { offset: stops[i][0], "stop-color": stops[i][1], "stop-opacity": stops[i][2] }));
    }
    return svgEl("radialGradient", { id: id, cx: cx, cy: cy, r: r }, nodes);
  }

  function polarPoint(deg, r) {
    var a = (deg * Math.PI) / 180;
    return (WHEEL_C + r * Math.cos(a)).toFixed(1) + " " + (WHEEL_C + r * Math.sin(a)).toFixed(1);
  }

  // i. dilim — 0. dilim tepede (ibrenin altında) ortalanır
  function slicePath(i, n) {
    var seg = 360 / n;
    var a0 = -90 + i * seg - seg / 2;
    var R = WHEEL_SLICE_R;
    return (
      "M" + WHEEL_C + " " + WHEEL_C +
      " L" + polarPoint(a0, R) +
      " A" + R + " " + R + " 0 " + (seg > 180 ? 1 : 0) + " 1 " + polarPoint(a0 + seg, R) +
      "Z"
    );
  }

  // Bricolage Grotesque ExtraBold için kaba karakter genişlikleri (em) — ilk çizim;
  // font yüklenince fitWheelLabels gerçek genişliğe göre düzeltir.
  function charEm(ch) {
    if (/[0-9]/.test(ch)) return 0.6;
    if (ch === "%") return 0.86;
    if (ch === " ") return 0.26;
    if (/[.,:;!'|iIlıİjtf]/.test(ch)) return 0.32;
    if (/[MWmw]/.test(ch)) return 0.9;
    if (ch !== ch.toLowerCase()) return 0.68;
    return 0.56;
  }

  function estimateWidth(text, size, spacing) {
    var em = 0;
    for (var i = 0; i < text.length; i++) em += charEm(text.charAt(i));
    return em * size + spacing * text.length;
  }

  // Taban çizgisi y'deki etiketin dilim kenarlarına değmeden alabileceği genişlik
  function maxLabelWidth(y, n, cap) {
    var d = WHEEL_C - y;
    var half = n > 2 ? d * Math.tan(Math.PI / n) : Infinity;
    return Math.max(20, Math.min(cap, 2 * half - 12));
  }

  function makeLine(text, y, base, weight, spacing, n, kind) {
    var max = maxLabelWidth(y, n, kind === "unit" ? 110 : 132);
    var est = estimateWidth(text, base, spacing);
    var size = est > max ? Math.max(WHEEL_LABEL_MIN_FONT, (base * max) / est) : base;
    return {
      text: text,
      y: y,
      base: base,
      size: +size.toFixed(1),
      weight: weight,
      spacing: spacing,
      max: +max.toFixed(1),
      kind: kind,
    };
  }

  function splitBalanced(s) {
    var mid = s.length / 2;
    var best = -1;
    for (var i = 0; i < s.length; i++) {
      if (s.charAt(i) === " " && (best < 0 || Math.abs(i - mid) < Math.abs(best - mid))) best = i;
    }
    return [s.slice(0, best), s.slice(best + 1)];
  }

  // Çok uzun etiketi kelime sınırında kısaltır (dilime sığması için font zaten küçülür)
  function clampLabel(s) {
    if (s.length <= WHEEL_LABEL_MAX_CHARS) return s;
    var cut = s.slice(0, WHEEL_LABEL_MAX_CHARS);
    var sp = cut.lastIndexOf(" ");
    return sp > WHEEL_LABEL_MAX_CHARS / 2 ? cut.slice(0, sp) : cut;
  }

  // "25 TL" → büyük "25" + küçük "TL"; "Tekrar Dene" → iki satır; "%10" → tek satır
  function labelLines(label, n) {
    var s = clampLabel(String(label == null ? "" : label).replace(/\s+/g, " ").trim());
    if (!s) return [];
    var m = /^(%\s?[\d.,]+|[\d.,]+\s?%?)\s+(\S.*)$/.exec(s);
    if (m) return [makeLine(m[1], 80, 30, 800, 0, n, "main"), makeLine(m[2], 100, 13, 600, 2, n, "unit")];
    if (s.length > 7 && s.indexOf(" ") > 0) {
      var parts = splitBalanced(s);
      var l1 = makeLine(parts[0], 82, 18, 800, 0, n, "word");
      var l2 = makeLine(parts[1], 101, 18, 800, 0, n, "word");
      var size = Math.min(l1.size, l2.size);
      l1.size = l2.size = size;
      l1.group = l2.group = "w";
      return [l1, l2];
    }
    return [makeLine(s, 88, 30, 800, 0, n, "main")];
  }

  // Etiketleri gerçek metin genişliğine göre sığdırır (font yüklendikten sonra tekrar çağrılır)
  function fitWheelLabels(svg) {
    if (!svg) return;
    var texts = svg.querySelectorAll("text[data-max]");
    var sizes = [];
    var lens = [];
    var groupMin = {};
    var i, t, g, est, max;
    for (i = 0; i < texts.length; i++) {
      t = texts[i];
      est = Number(t.getAttribute("data-fs"));
      max = Number(t.getAttribute("data-max"));
      var base = Number(t.getAttribute("data-base"));
      t.setAttribute("font-size", String(est));
      t.removeAttribute("textLength");
      t.removeAttribute("lengthAdjust");
      var len = 0;
      try {
        len = t.getComputedTextLength();
      } catch (e) {}
      lens[i] = len;
      sizes[i] = len ? Math.max(WHEEL_LABEL_MIN_FONT, Math.min(base, (est * max) / len)) : est;
      g = t.getAttribute("data-group");
      if (g) groupMin[g] = Math.min(groupMin[g] == null ? Infinity : groupMin[g], sizes[i]);
    }
    for (i = 0; i < texts.length; i++) {
      t = texts[i];
      g = t.getAttribute("data-group");
      var size = g ? groupMin[g] : sizes[i];
      t.setAttribute("font-size", size.toFixed(1));
      // En küçük fontta bile sığmıyorsa komşu dilime taşmasın — yatayda sıkıştır
      est = Number(t.getAttribute("data-fs"));
      max = Number(t.getAttribute("data-max"));
      if (lens[i] && est && (lens[i] * size) / est > max + 0.5) {
        t.setAttribute("textLength", String(max));
        t.setAttribute("lengthAdjust", "spacingAndGlyphs");
      }
    }
  }

  function ensureWheelFont(cb) {
    if (cb) {
      if (wheelFontState === 2) {
        cb();
        return;
      }
      wheelFontCallbacks.push(cb);
    }
    if (wheelFontState !== 0) return;
    wheelFontState = 1;
    function done() {
      wheelFontState = 2;
      var list = wheelFontCallbacks;
      wheelFontCallbacks = [];
      for (var i = 0; i < list.length; i++) list[i]();
    }
    if (document.fonts && document.fonts.load) {
      Promise.all([
        document.fonts.load("800 30px 'Bricolage Grotesque'", WHEEL_FONT_SAMPLE),
        document.fonts.load("600 13px 'Bricolage Grotesque'", WHEEL_FONT_SAMPLE),
      ]).then(done, done);
    } else {
      done();
    }
  }

  function buildWheel(prizes, appearance, onHubClick) {
    var n = prizes.length;
    var seg = 360 / n;
    var i, j;

    var slices = [];
    var labels = [];
    for (i = 0; i < n; i++) {
      var p = prizes[i] || {};
      var color = p.color || (i % 2 ? appearance.sliceColorB : appearance.sliceColorA) || WHEEL_COLORS.jewel;
      var isGold = String(color).toLowerCase() === WHEEL_GOLD_SLICE;
      var fill = isGold ? "url(#gw-wheel-gold)" : color;
      slices.push(
        n === 1
          ? svgEl("circle", { cx: WHEEL_C, cy: WHEEL_C, r: WHEEL_SLICE_R, fill: fill })
          : svgEl("path", { d: slicePath(i, n), fill: fill })
      );

      var textColor = p.textColor || appearance.sliceTextColor || "#ffffff";
      var lines = labelLines(p.label, n);
      var texts = [];
      for (j = 0; j < lines.length; j++) {
        var l = lines[j];
        var t = svgEl("text", {
          x: WHEEL_C,
          y: l.y,
          fill: textColor,
          "font-size": l.size,
          "font-weight": l.weight,
          "letter-spacing": l.spacing || null,
          opacity: l.kind === "unit" && !isGold ? 0.85 : null,
          "data-max": l.max,
          "data-fs": l.size,
          "data-base": l.base,
          "data-group": l.group ? l.group + i : null,
        });
        t.textContent = l.text;
        texts.push(t);
      }
      labels.push(svgEl("g", { transform: "rotate(" + (i * seg).toFixed(2) + " 200 200)" }, texts));
    }

    var bulbs = [];
    for (i = 0; i < WHEEL_BULB_COUNT; i++) {
      var a = ((-90 + (i * 360) / WHEEL_BULB_COUNT) * Math.PI) / 180;
      var odd = i % 2 === 1;
      bulbs.push(
        svgEl("circle", {
          cx: (WHEEL_C + WHEEL_BULB_RING_R * Math.cos(a)).toFixed(1),
          cy: (WHEEL_C + WHEEL_BULB_RING_R * Math.sin(a)).toFixed(1),
          r: odd ? 4.5 : 5,
          fill: odd ? WHEEL_COLORS.bulbB : WHEEL_COLORS.bulbA,
          class: odd ? "gw-bulb-b" : "gw-bulb-a",
        })
      );
    }

    var svg = svgEl(
      "svg",
      { class: "gw-wheel-svg", viewBox: "0 0 400 400", "aria-hidden": "true", focusable: "false" },
      [
        svgEl("defs", null, [
          radialGradient("gw-wheel-rim", "50%", "35%", "70%", [
            ["0%", WHEEL_COLORS.rimLight],
            ["55%", WHEEL_COLORS.rimMid],
            ["100%", WHEEL_COLORS.rimDark],
          ]),
          radialGradient("gw-wheel-gold", "50%", "10%", "90%", [
            ["0%", WHEEL_COLORS.goldLight],
            ["100%", "#E9A90C"],
          ]),
          radialGradient("gw-wheel-shade", "50%", "50%", "50%", [
            ["60%", "#000000", 0],
            ["100%", "#000000", 0.35],
          ]),
          svgEl("filter", { id: "gw-wheel-glow", x: "-100%", y: "-100%", width: "300%", height: "300%" }, [
            svgEl("feGaussianBlur", { stdDeviation: 2.2, result: "b" }),
            svgEl("feMerge", null, [svgEl("feMergeNode", { in: "b" }), svgEl("feMergeNode", { in: "SourceGraphic" })]),
          ]),
        ]),
        svgEl("circle", { cx: WHEEL_C, cy: WHEEL_C, r: WHEEL_RIM_R, fill: "url(#gw-wheel-rim)" }),
        svgEl("circle", { cx: WHEEL_C, cy: WHEEL_C, r: WHEEL_INNER_R, fill: WHEEL_COLORS.inner }),
        svgEl("g", { stroke: WHEEL_COLORS.separator, "stroke-width": 2, "stroke-linejoin": "round" }, slices),
        svgEl("circle", { cx: WHEEL_C, cy: WHEEL_C, r: WHEEL_SLICE_R, fill: "url(#gw-wheel-shade)" }),
        svgEl("g", { "font-family": WHEEL_FONT_FAMILY, "text-anchor": "middle" }, labels),
        svgEl("g", { filter: "url(#gw-wheel-glow)" }, bulbs),
      ]
    );

    var rotor = el("div", { class: "gw-wheel-rotor" });
    rotor.appendChild(svg);

    var pin = svgEl("svg", { class: "gw-pin", viewBox: "0 -10 44 66", "aria-hidden": "true", focusable: "false" }, [
      svgEl("path", {
        d: "M22 54 L4 20 A20 20 0 1 1 40 20 Z",
        fill: WHEEL_COLORS.separator,
        stroke: WHEEL_COLORS.rimDark,
        "stroke-width": 2,
      }),
      svgEl("circle", { cx: 22, cy: 19, r: 7, fill: WHEEL_COLORS.jewel, stroke: WHEEL_COLORS.rimDark, "stroke-width": 1.5 }),
    ]);

    var hub = el("button", { class: "gw-hub", type: "button", "aria-label": "Çarkı çevir", text: HUB_LABEL });
    hub.addEventListener("click", function () {
      if (onHubClick) onHubClick();
    });

    var wrap = el("div", { class: "gw-wheel-wrap" }, [
      el("div", { class: "gw-wheel-glow" }),
      el("div", { class: "gw-wheel-clip" }, [rotor]),
      pin,
      hub,
    ]);

    return {
      wrap: wrap,
      svg: svg,
      rotor: rotor,
      setBusy: function (busy) {
        hub.disabled = !!busy;
        hub.textContent = busy ? "..." : HUB_LABEL;
      },
      lock: function () {
        hub.disabled = true;
        hub.textContent = HUB_LABEL;
      },
    };
  }

  // index. dilimi ibrenin altına getirir (6 tur, 5 sn, yavaşlayarak durur; sonuç 200ms sonra)
  function spinWheel(rotor, index, n, onDone) {
    var seg = 360 / n;
    var target = 360 * WHEEL_SPIN_TURNS + ((((360 - index * seg) % 360) + 360) % 360);
    rotor.style.transition = "transform " + WHEEL_SPIN_MS + "ms " + WHEEL_SPIN_EASE;
    void rotor.offsetWidth; // reflow
    rotor.style.transform = "rotate(" + target + "deg)";
    setTimeout(function () {
      if (onDone) onDone();
    }, WHEEL_RESULT_DELAY_MS);
  }

  function copyText(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
        return;
      }
    } catch (e) {}
    try {
      var ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    } catch (e) {}
  }
})();
